import http from './axios';

export default class DashboardServices {
  private readonly manage_api = '/v1/dashboard/manage-plate';
  private readonly journey_api = '/v1/dashboard/customer-journey';
  private readonly all_alert_api = '/v1/dashboard/all-alert-data';
  private readonly sort_api = '/v1/dashboard/sort';
  private readonly trend_api = '/v1/dashboard/trend-analyze';

  constructor() {}

  async getManagePlate(params?: object): Promise<any> {
    let res: any = await http.get(this.manage_api, { params: params });
    return res.payload;
  }

  async getCustomerJourney(params?: object): Promise<any> {
    let res: any = await http.get(this.journey_api, { params: params });
    return res.payload;
  }

  async getAllAlert(params?: object): Promise<any> {
    let res: any = await http.get(this.all_alert_api, { params: params });
    return res.payload;
  }

  async getSort(params?: object): Promise<any> {
    let res: any = await http.get(this.sort_api, { params: params });
    return res.payload;
  }

  async getTrend(params?: object): Promise<any> {
    let res: any = await http.get(this.trend_api, { params: params });
    return res.payload;
  }
}
